module.exports = __webpack_public_path__ + "img/gb93-87_8.prt.db0018e9.jpg";